import React from 'react';
import { useParams } from 'react-router-dom';
//import { usePlateWellActions } from '../../../store/plateWellStore';
import { useSelecetedAnalysisType, useTabValue } from '../../../store/plateWellStore';
import SingleWellAnalysis from '../../platewells/Analysis/SingleWellAnalysis';
import { Analysis } from '../../constants/analysisType';
import ReplicateAnalysisDisplay from '../../platewells/Analysis/ReplicateAnalysisDisplay';
import ControlAnalysisDisplay from '../../platewells/Analysis/ControlAnalysisDisplay';
import useFetchQlp96WellMetrics from '../../Hooks/qlp_ddpcr/useFetchQlp96WellMetrics';


const AnalysisResult = () => {
    //   const { setSelectedAnanlysisType } = usePlateWellActions();
    const { plate_uuid } = useParams();
    const { data, isSuccess } = useFetchQlp96WellMetrics(plate_uuid);
    const plateName = isSuccess ? data?.data[3] : '';

    const selectedAnalysisType = useSelecetedAnalysisType();
    const tabValue = useTabValue();
    return (
        <>
            <h1 className='pb-5'>Analysis Results: {selectedAnalysisType}</h1>
            <span className='font-bold text-custom-green'>Plate Name: {plateName}</span>
            <div className='pt-10 flex justify-center flex-col h-full max-h-[80vh] border-2 border-solid pb-10 items-center'>

                {selectedAnalysisType === Analysis.singlewell ? <SingleWellAnalysis /> :
                    selectedAnalysisType === Analysis.replicate ? <ReplicateAnalysisDisplay /> :
                        selectedAnalysisType === Analysis.controlexp ? <ControlAnalysisDisplay /> :
                            <p>No Analysis selected for caliberation and display</p>}
            </div>
            <div className="">

            </div>
        </>
    );
}

export default AnalysisResult;